import { useState, useRef } from 'react'

const MAX_SCREENSHOT_SIZE = 5 * 1024 * 1024 // 5MB

/** Reads a picked image into raw base64 (no data-URL prefix), reporting problems through `onError`. */
export function useScreenshotAttachment(onError: (message: string) => void) {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [screenshot, setScreenshot] = useState<string | null>(null)
  const [screenshotName, setScreenshotName] = useState('')

  const handleScreenshot = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    if (file.size > MAX_SCREENSHOT_SIZE) {
      onError('Screenshot must be under 5MB')
      return
    }

    onError('')
    setScreenshotName(file.name)

    const reader = new FileReader()
    reader.onload = () => {
      // Strip the data URL prefix to get raw base64
      const result = reader.result as string
      const base64 = result.split(',')[1]
      setScreenshot(base64)
    }
    reader.readAsDataURL(file)
  }

  const reset = () => {
    setScreenshot(null)
    setScreenshotName('')
  }

  const removeScreenshot = () => {
    reset()
    if (fileInputRef.current) fileInputRef.current.value = ''
  }

  return { fileInputRef, screenshot, screenshotName, handleScreenshot, removeScreenshot, reset }
}
